import { render, staticRenderFns } from "./articaside.vue?vue&type=template&id=32255269&"
import script from "./articaside.vue?vue&type=script&lang=js&"
export * from "./articaside.vue?vue&type=script&lang=js&"
import style0 from "./articaside.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports